import { Button } from "../../ui-kit/Button/Button";
import { Input } from "../../ui-kit/Input/Input";
import { Row } from "../../ui-kit/Row/Row";
import { Text } from "../../ui-kit/Text/Text";

export const Contacts = () => {
  return (
    <div>
      <Input placeholder="Твое имя" />
      <Input placeholder="Твоя почта" />
      <Input placeholder="Сообщение" />
      <Button style={{ marginRight: 10 }}>
        <Text color="white">Отправить</Text>
      </Button>
    </div>
  );
};
